module.exports = __webpack_public_path__ + "static/media/selection-2.b32c62ab.jpg";